import './DetailItem.css';
import { memo } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import ItemType from '../types/item';
import { itemImages } from '../items';

function DetailItem({ items, id, addToCart }) {
  const detailItem = items.find((item) => item.itemId === id);

  const addItemToCart = () => {
    addToCart(detailItem.itemId);
  };
  return (
    <div className="detail-item-component">
      {detailItem ? (
        <>
          {detailItem.salePrice != null && <div>On Sale!</div>}
          <img
            className="details-image"
            src={itemImages[detailItem.imageId]}
            alt={detailItem.title}
          />
          <h2>{detailItem.title}</h2>
          {!!detailItem.description && <h6>{detailItem.description}</h6>}
          <div>
            $
            {(detailItem.salePrice ?? detailItem.price).toFixed(2)}
          </div>
          <button type="button" onClick={addItemToCart}>Add to Cart</button>
        </>
      ) : (
        <div>No Item Selected</div>
      )}
    </div>
  );
}

const sharedProps = {
  items: PropTypes.arrayOf(ItemType).isRequired,
  addToCart: PropTypes.func.isRequired,
};
DetailItem.propTypes = {
  ...sharedProps,
  id: PropTypes.string.isRequired,
};

const DetailItemMemo = memo(DetailItem);
function DetailsOuter({ items, addToCart }) {
  const { id } = useParams();
  return <DetailItemMemo items={items} id={id} addToCart={addToCart} />;
}
DetailsOuter.propTypes = sharedProps;
export default DetailsOuter;
